import { useLayoutEffect, useRef } from 'react';
import type { MotionValue } from 'framer-motion';

// src/hooks/useLayoutMotionValueEvent.ts
// framer-motion 12's useMotionValueEvent subscribes inside useInsertionEffect.
// React 19 forbids scheduling updates from that phase, and an inline callback
// (new every render) re-subscribes on every commit. Combined with currentTime.set()
// from the host clock this nested-updates past React's limit.

type MotionChangeCallback<T> = (value: T) => void;

export function useLayoutMotionValueEvent<T>(
    value: MotionValue<T>,
    event: 'change',
    callback: MotionChangeCallback<T>,
): void {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useLayoutEffect(() => {
        return value.on(event, (latest) => {
            callbackRef.current(latest);
        });
    }, [value, event]);
}
